$(document).ready(function () {

    //== Expanding List
    //
    // Used on L2 and L3 Pages to collapse/expand link lists
    $('.expanding-list').each(function (index) {

        var lis = $(this).find('li[class!="collapse-container"]').slice(5);
        if (lis.length >= 1) {
            var hiddenList = $(this).find(".collapse-content");
            $(lis).detach().appendTo(hiddenList);
            $(this).find(".collapse-container").show();
        } else {
            $(this).find(".collapse-container").hide();
        }
    });
});